(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lp-reviews')) {
    class LpReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.pauseButton = this.querySelector('[data-pause]');
        const dotWrap = this.querySelector('[data-dots]');
        if (dotWrap && !dotWrap.children.length) {
          this.slides.forEach((slide, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'lprv__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Show review ' + (i + 1));
            dot.dataset.dot = i;
            dotWrap.appendChild(dot);
          });
        }
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (!this.track || this.slides.length < 2) {
          this.querySelectorAll('[data-prev], [data-next], .lprv__controls').forEach((el) => (el.hidden = true));
          return;
        }
        this.delay = Math.max(3, parseInt(this.dataset.seconds, 10) || 10) * 1000;
        this.index = 0;
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.holds = new Set();
        this.visible = false;
        this.classList.toggle('is-paused', this.userPaused);
        this.updatePauseLabel();

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10), true)));
        this.pauseButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.classList.toggle('is-paused', this.userPaused);
          this.updatePauseLabel();
          this.restart();
        });

        this.addEventListener('mouseenter', () => this.hold('hover'));
        this.addEventListener('mouseleave', () => this.release('hover'));
        this.addEventListener('focusin', () => this.hold('focus'));
        this.addEventListener('focusout', () => this.release('focus'));
        this.track.addEventListener('pointerdown', () => this.restart(), { passive: true });

        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            this.index = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth));
            this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.index));
            ticking = false;
          });
        }, { passive: true });

        this.onVisibility = () => (document.hidden ? this.hold('tab') : this.release('tab'));
        document.addEventListener('visibilitychange', this.onVisibility);

        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          this.restart();
        }, { threshold: 0.3 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      updatePauseLabel() {
        this.pauseButton?.setAttribute('aria-label', this.userPaused ? 'Play the reviews' : 'Pause the reviews');
      }

      go(i, fromUser) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'smooth' });
        this.dots.forEach((d, j) => d.classList.toggle('is-active', j === this.index));
        if (fromUser) this.restart();
      }

      hold(reason) { this.holds.add(reason); clearTimeout(this.timer); }
      release(reason) { this.holds.delete(reason); this.restart(); }

      restart() {
        clearTimeout(this.timer);
        if (this.userPaused || !this.visible || this.holds.size) return;
        this.timer = setTimeout(() => { this.go(this.index + 1); this.restart(); }, this.delay);
      }
    }
    customElements.define('lp-reviews', LpReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
